export default "__VITE_ASSET__a7963cc8__"